<form [formGroup]="templateForm" class="space-y-4 mt-2" (submit)="save()">

  <div class="grid grid-cols-1 md:grid-cols-1 gap-4">
    <p-floatlabel variant="on">
      <textarea pTextarea id="over_label" formControlName="text" rows="5" cols="30" style="resize: none" class="h-full w-full"></textarea>
      <label for="on_label">Inserisci Messaggio</label>
    </p-floatlabel>
  </div>

  <div class="flex justify-end gap-2">
    <p-button label="Cancella" icon="pi pi-times-circle" size="small" severity="secondary" (click)="closeDialog()"/>
    <p-button label="Salva" icon="pi pi-check-circle" size="small" [disabled]="!templateForm.valid" type="submit"/>
  </div>
</form>
